import React from "react";
import { ReactComponent as Check } from "../assets/svg/check.svg";
import styled, { css } from "styled-components";

const ListTitles = ({ items = [], onClickItem = () => {}, noOpacity = false, allowAll = false }) => {
  let activated = -1;
  return (
    <Container>
      {items.map((item, index) => {
        if (activated === -1 && item.purchased && !item.completed)
          activated = index;

        const allow =
          (item.free && !item.purchased) ||
          (item.purchased && (activated === -1 || activated === index)) ||
          allowAll;

        return (
          <Row
            key={item.id}
            allow={allow}
            purchased={item.purchased}
            onClick={() => (allow ? onClickItem(item) : null)}
            noOpacity={noOpacity}
          >
            <Title>{item.title}</Title>
            {item.completed && <StateIcon as={Check} />}
            {item.attempt && <Attempt>{item.attempt}</Attempt>}
          </Row>
        );
      })}
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  border-radius: 20px;
  overflow: hidden;
`;

const Row = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: space-between;
  padding: 20px 25px;
  box-sizing: border-box;

  border-width: 0px 5px 0px 0px;
  border-style: solid;
  border-color: transparent;

  ${(props) =>
    props.allow
      ? css`
          cursor: pointer;
          background-color: white;
        `
      : css`
          cursor: default;
          background-color: #f5f5f5;
          & > * {
            opacity: ${props.noOpacity ? 1 : 0.5};
          }
        `}

  ${(props) =>
    props.purchased &&
    css`
      border-color: #2196f3;
    `}
`;

const Attempt = styled.div`
  width: 20px;
  height: 20px;
  min-width: 20px;
  min-height: 20px;
  border-radius: 50%;
  overflow: hidden;
  background-color: #ec407a;
  color: white;
  font-size: 0.7em;
  font-weight: 600;
`;

const StateIcon = styled.div`
  width: 20px;
  height: 20px;
  min-width: 20px;
  min-height: 20px;
`;

const Title = styled.div`
  font-size: 0.9em;
  user-select: none;
`;

export default ListTitles;
